import React from 'react'
import { Link, useLocation } from 'react-router-dom'

export default function Footer() {
  const location = useLocation()

  if (location.pathname === "/adminPanel/addblog" || location.pathname === "/adminPanel/allposts" || location.pathname === "/adminPanel/allcategory" || location.pathname === "/adminPanel/addcategory" || location.pathname === "/adminPanel/board" || location.pathname === "/adminPanel/alltickets") {
    return null;
  }
return (
    <footer id="footer">
      <div className='footerBg'>
        <div className="footer-top footeroverlay">
          <div className="container">
            <div className="row justify-content-between py-2 g-2">

              <div className="col-lg-3 col-md-6 footer-contact text-start">
                <h2>Technic Mentors</h2>
                <p className='mb-1'>
                  <i className='fas fa-map-marker-alt me-2'></i>
                  United Kingdom | Norway | Pakistan
                </p>
                <p className='mb-1'>
                  <i className='fas fa-phone me-2'></i>
                  <a style={{ textDecoration: "none", color: "white" }} href='tel:+923 111 122 144'> +923 111 122 144</a>
                </p>
                <p className='mb-1'>
                  <i className='fas fa-envelope me-2'></i>
                  info@technicmentors.com
                </p>
              </div>

              <div className="col-md-5 text-start footer-subscribe">
                <h2>Subscribe</h2>
                <p className='mb-2'>Stay updated on how future of technology is shaping</p>
                <div className='d-flex'>
                  <input type='text' className='form-control bg-transparent py-2' placeholder='Enter Your Email Here'></input>
                  <button className='btn btn-light px-4' style={{ marginLeft: "2%" }}>Submit</button>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 footer-links">
                <h2>Our Social Links</h2>
                <p className='mb-2'>Follow us on all social channels to get the latest updates regarding our services.</p>
                <div className="social-links mt-2">
                  <a href="https://www.facebook.com/TechnicMentors" target='blank' className="facebook"><i className="bx bxl-facebook"></i><span className="d-none">book</span></a>
                  <a href="https://twitter.com/TechnicMentors" target='blank' className="twitter"><i className="bx bxl-twitter"></i><span className="d-none">tter</span></a>
                  <a href="https://www.instagram.com/technicmentorsofficial" target='blank' className="instagram"><i className="bx bxl-instagram"></i><span className="d-none">gram</span></a>
                  <a href="https://www.youtube.com/c/TechnicMentors" target='blank' className="youtube"><i className="bx bxl-youtube"></i><span className="d-none">tube</span></a>
                  <a href="https://www.linkedin.com/company/technicmentors/" target='blank' className="linkedin"><i className="bx bxl-linkedin"></i><span className="d-none">in</span></a>
                </div>
              </div>

            </div>

        <div className="d-flex justify-content-between align-items-center flex-wrap border-top py-2 mt-1 gap-2 pb-4 pb-md-2">
  <div className="d-flex flex-wrap gap-3" style={{ fontSize: "0.85rem" }}>
    <Link className="text-white text-decoration-none" to="/help">Knowledgebase</Link>
    <Link className="text-white text-decoration-none" to="/blog">Blogs</Link>
    <Link className="text-white text-decoration-none" to="/faq-page">FAQ's</Link>
    <Link className="text-white text-decoration-none" to="/contact">Contact</Link>
    <Link className="text-white text-decoration-none" to="/privacy-policy">Privacy Policy</Link>
  </div>
  <p className="mb-0 text-white" style={{ fontSize: "0.80rem", marginRight: "30px" }}>
    &copy; {new Date().getFullYear()} <strong>Technic Mentors. All Rights Reserved</strong>
  </p>
</div>

          </div>
        </div>
      </div>
    </footer>
  )
}